import React, { useState } from "react";

import { Pane, Typography } from "clearsense-ui/components";
import { useMetaIQDispatch } from "contexts/metaIQ";

import Category from "./Category";
import DatabaseType from "./DatabaseType";
import Verify from "./Verify";

const ClassificationPane = ({
  fetchDatabaseDetails,
  isAddNewClassification,
  setIsAddNewClassification,
}) => {
  const [step, setStep] = useState("categories");
  const metaIQDispatch = useMetaIQDispatch();

  const onClose = () => {
    setIsAddNewClassification(false);
    setStep("categories");
    metaIQDispatch({
      type: "SET_CATEGORY",
      payload: { categories: [] },
    });
    metaIQDispatch({
      type: "SET_DATABASE_DETAILS",
      payload: { databaseDetails: {} },
    });
  };

  return (
    <Pane size="md" isOpen={isAddNewClassification} onClose={onClose}>
      <Pane.Header>
        <Typography style="h3" type="bold" className="-mt-3">
          Add a Meta IQ Classification
        </Typography>
      </Pane.Header>
      {step === "categories" && (
        <Category onClose={onClose} setStep={setStep} />
      )}
      {step === "database details" && (
        <DatabaseType onClose={onClose} setStep={setStep} />
      )}
      {step === "verify" && (
        <Verify
          fetchDatabaseDetails={fetchDatabaseDetails}
          onClose={onClose}
          step={step}
          setStep={setStep}
        />
      )}
    </Pane>
  );
};

export default ClassificationPane;
